import { render, staticRenderFns } from "./ShippersDeclarationSite.vue?vue&type=template&id=24a9f514&scoped=true"
import script from "./ShippersDeclarationSite.vue?vue&type=script&lang=js"
export * from "./ShippersDeclarationSite.vue?vue&type=script&lang=js"
import style0 from "./ShippersDeclarationSite.vue?vue&type=style&index=0&id=24a9f514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9f514",
  null
  
)

export default component.exports